/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { CosmosComponentContextProps, getHero, getSections, useCosmosComponentContext } from "@cosmos/components";
import { PageHeroesFragment, RefSectionsFragment } from "@cosmos/hygraph-schema";
import { useAuth } from "@cosmos/next-hooks";

import { TemplateProviders } from "./templates/TemplateProviders";

interface BasePageData {
	hero?: PageHeroesFragment | null;
	refSections?: RefSectionsFragment[] | null;
}

interface Props<T> {
	pageData?: T;
	componentContext?: CosmosComponentContextProps;
}

export const ClientPageProviders = <T extends BasePageData>({
	pageData,
	componentContext,
}: Props<T>): React.JSX.Element => {
	const contextFromProvider = useCosmosComponentContext();
	const ctx = componentContext ?? contextFromProvider;
	useAuth(!ctx.enableAuth);

	return (
		<TemplateProviders componentContext={ctx}>
			{getHero(pageData?.hero)}
			{getSections(pageData?.refSections)}
		</TemplateProviders>
	);
};
